<!--  -->
<template>
  <div v-html='content' class="privacy"></div>
</template>

<script>
import Api from '@/api/my'
export default {
  components: {},
  data() {
    return {
      content: '',
    };
  },
  computed: {},
  watch: {},
  created() {
    Api.getPrivacy({
      protocol_type: this.$route.query.type
    }).then(res => {
      if (res.status == 200) {
        this.content = res.data.protocol_cont
      } else {
        this.$message({
          message: res.message || '协议获取失败',
          type: 'error',
        })
      }
    })
  },
  mounted() {
    
  },
  //方法集合
  methods: {
    
  },
}
</script>

<style lang='less' scoped>
.privacy {
  padding: 0 20px;
  background-color: #fff;
}
</style>